import gql from 'graphql-tag';
import { GetAllUserMonthBonus } from './allUserMonthBonusApi';

const SetStateAllUserMonthBonusesMutation = gql`
  mutation SetStateAllUserMonthBonuses($input: UserMonthBonusSetStateInput!) {
   user_month_bonus_set_state(input: $input) {
      id
    }
  }
`;

export const setStateAllUserMonthBonusesSummaryApi = async (
  client,
  allUserMonthBonusesIdsArray,
  setNextState,
  bonusMonth,
  districtId,
  departmentId,
  monthBonusState,
) => {
  const variables = {
    input: {
      state: setNextState,
      user_month_bonus_ids: allUserMonthBonusesIdsArray,
    },
  };

  const options = {
    mutation: SetStateAllUserMonthBonusesMutation,
    variables,
    refetchQueries: [
      {
        query: GetAllUserMonthBonus,
        variables: { bonusMonth, districtId, departmentId, monthBonusState },
      },
    ],
  };

  const result = await client.mutate(options);
  return {
    result,
  };
};
